import {InjectionToken} from '@angular/core';

export const FACET_MODAL_DATA = new InjectionToken('facet.data');
